import { Section } from "../../../components/Section";
import { SectionSubTitle } from "../../../components/SectionTitle";
import { Spacer } from "../../../components/Spacer";
import { BusSvg } from "../../../components/Svg/Icons/Bus";
import { ChurchSvg } from "../../../components/Svg/Icons/Church";
import { CocktelSvg } from "../../../components/Svg/Icons/Cocktel";
import { DanceSvg } from "../../../components/Svg/Icons/Dance";
import { DrinksSvg } from "../../../components/Svg/Icons/Drinks";
import { FoodSvg } from "../../../components/Svg/Icons/Food";
import { ReceptionSvg } from "../../../components/Svg/Icons/Reception";
import { TimeLine } from "../../../components/TimeLine";

export const Activities = () => {
  return (
    <>
      <SectionSubTitle title="Agenda" />

      <Spacer />
      <Spacer />

      <div className="grid grid-cols-1 gap-4 md:gap-0 max-w-300 m-auto">
        <TimeLine
          items={[
            {
              id: 1,
              date: "12:00",
              title: "Ceremonia Religiosa",
              description: "",
              icon: ChurchSvg,
            },
            {
              id: 2,
              date: "13:30",
              title: "Traslado a la hacienda",
              description: "",
              icon: BusSvg,
            },
            {
              id: 3,
              date: "14:00",
              title: "Recepción",
              description: "",
              icon: ReceptionSvg,
            },
            {
              id: 4,
              date: "14:30",
              title: "Cóctel",
              description: "",
              icon: CocktelSvg,
            },
            {
              id: 5,
              date: "16:00",
              title: "Banquete",
              description: "",
              icon: FoodSvg,
            },
            {
              id: 6,
              date: "17:30",
              title: "Fiesta",
              description: "",
              elId: "confetti",
              icon: DrinksSvg,
            },
            {
              id: 7,
              date: "01:00",
              title: "Último baile",
              description: "",
              icon: DanceSvg,
            },
          ]}
        />
      </div>
    </>
  );
};
